module.exports = __webpack_public_path__ + "static/img/logo.a54c5b98.png";